import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  id: 1,
  name: 'Анна К.',
  text: 'Якість просто неймовірна. Я замовила приталений вовняний жакет, і він сидить так, ніби був пошитий спеціально для мене. Пакування також було чудовим.',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=150&h=150'
}, {
  id: 2,
  name: 'Олена М.',
  text: 'Я місяцями шукала ідеальну шовкову сукню-комбінацію. Бордова від na.lilu перевершила всі мої очікування. Обслуговування клієнтів було неймовірно корисним у підборі розміру.',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=150&h=150'
}, {
  id: 3,
  name: 'Вікторія С.',
  text: 'Прекрасний дизайн та бездоганний крій. Ви дійсно можете відчути преміальну якість тканин. Я вже планую свою наступну покупку!',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=150&h=150'
}];
export function Testimonials() {
  return <section id="reviews" className="py-24 bg-white" data-id="element-300" data-mp="m62os3lp85tb">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301" data-mp="m2op534f6apk">
        <div className="text-center mb-16" data-id="element-302" data-mp="79bn1nojyi0j">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-303" data-mp="c6v9havem13k">
            Любов клієнтів
          </h2>
          <p className="text-brand-dark/70 max-w-2xl mx-auto" data-id="element-304" data-mp="zw64sctzj3ab">
            Не вірте нам на слово. Ось що кажуть наші чарівні клієнтки.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-305" data-mp="14xdcyd01i4hi">
          {reviews.map((review, index) => <motion.div key={review.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-brand-cream p-8 rounded-2xl" data-id="element-306" data-mp="v5ppen6lt7lb" data-mpi={index}>
              <div className="flex gap-1 mb-6" data-id="element-307" data-mp="1ohau8ebj2jom">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-burgundy text-brand-burgundy" data-id="element-308" data-mp="1ji80hq0zzzvy" data-mpi={i} />)}
              </div>
              <p className="text-brand-dark/80 italic mb-8 min-h-[100px]" data-id="element-309" data-mp="1ekzjhsrl61wa">
                "{review.text}"
              </p>
              <div className="flex items-center gap-4" data-id="element-310" data-mp="14stpyelorcez">
                <img src={review.avatar} alt={review.name} className="w-12 h-12 rounded-full object-cover" data-id="element-311" data-mp="14r8vsq3a9vhn" />
                <div data-id="element-312" data-mp="vs3y1lzjq66j">
                  <h4 className="font-medium text-brand-dark" data-id="element-313" data-mp="vuq39eyys9ll">{review.name}</h4>
                  <p className="text-xs text-brand-dark/60 uppercase tracking-wider" data-id="element-314" data-mp="qu2ekzy7k4uj">
                    Перевірений покупець
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}